import { Routes } from '@angular/router';
import { IncomeProofBottomsheetComponent } from './components/income-proof-bottomsheet/income-proof-bottomsheet.component';
import { IncomeProofNextStepComponent } from './components/income-proof-next-step/income-proof-next-step.component';
import { FailureComponent } from './pages/failure/failure.component';
import { MissingDetailsComponent } from './pages/missing-details/missing-details.component';
import { DerivativeDetailsComponent } from './pages/derivative-details/derivative-details.component';
import { IncomeDetailsComponent } from './pages/income-details/income-details.component';
import { segmentGuard } from './guard/segment.guard';
import { LoaderComponent } from './pages/loader/loader.component';
import { TryAgainComponent } from './pages/try-again/try-again.component';
import { SuccessComponent } from './pages/success/success.component';
import { TimingLoaderComponent } from './pages/timing-loader/timing-loader.component';
import { ProofSelectionComponent } from './pages/proof-selection/proof-selection.component';
import { ProofOptionComponent } from './pages/proof-option/proof-option.component';


export const routes: Routes = [
       {
        path: '',
        pathMatch: 'full',
        redirectTo: 'derivative/segment-details',
    },
    {
        path: 'derivative',
        children: [
            {
            path: '',
            pathMatch: 'full',
            redirectTo: 'segment-details',
            },
            {
                path: 'segment-details',
                component: DerivativeDetailsComponent
            },
            {
                path: 'income-details',
                component: IncomeDetailsComponent
            },
            {
                path: 'proof-selection',
                component: ProofSelectionComponent
            },
            {
                path: 'loader',
                component: LoaderComponent,
                // canActivate: [segmentGuard]
            },
            {
                path: 'successfull-request',
                component: SuccessComponent
            },
            {
                path: 'try-again',
                component: TryAgainComponent
            },
            {
                path: 'missing-details',
                component: MissingDetailsComponent
            },
            {
                path: 'loader-with-time',
                component: TimingLoaderComponent
            },
            {
                path: 'fail-page',
                component: FailureComponent
            },
        ]
    },

    // {
    //     path: 'segment-details',
    //     component: DerivativeDetailsComponent
    // },
    // {
    //     path: 'income-details',
    //     component: IncomeDetailsComponent
    // },
    // {
    //     path: 'proof-selection',
    //     component: ProofSelectionComponent
    // },
    // {
    //     path: 'loader',
    //     component: LoaderComponent,
    //     canActivate: [segmentGuard]
    // },
    // {
    //     path: 'success',
    //     component: SuccessComponent
    // },
    // {
    //     path: 'try-again',
    //     component: TryAgainComponent
    // },
    // {
    //     path: 'missing-details',
    //     component: MissingDetailsComponent
    // },
    // {
    //     path: 'loader-with-time',
    //     component: TimingLoaderComponent
    // },
    // {
    //     path: 'fail-page',
    //     component: FailureComponent
    // },
];
